import { DetailsRows, type TDetailsRow } from '@ds/components'

import { buildMoreInfoNodes, type TMoreInfoValues } from '../../helpers/buildMoreInfoNodes'

import styles from './AudioMusicDetails.module.css'

type TAudioMusicDetailsProps = {
    heading: string
    /** Values the SEO "more info" paragraph is written around. */
    moreInfo: TMoreInfoValues
    rows: TDetailsRow[]
    detailsAriaLabel: string
}

export const AudioMusicDetails = ({
    heading,
    moreInfo,
    rows,
    detailsAriaLabel,
}: TAudioMusicDetailsProps) => (
    <section className={styles.section}>
        <div className={styles.moreInfo}>
            <h3 className={styles.heading}>{heading}</h3>
            <p className={styles.description}>{buildMoreInfoNodes(moreInfo)}</p>
        </div>
        <DetailsRows rows={rows} ariaLabel={detailsAriaLabel} />
    </section>
)
